import { render, staticRenderFns } from "./GroupedFieldItem.vue?vue&type=template&id=00dbe9b0&scoped=true&lang=html&"
import script from "./GroupedFieldItem.vue?vue&type=script&lang=js&"
export * from "./GroupedFieldItem.vue?vue&type=script&lang=js&"
import style0 from "./GroupedFieldItem.vue?vue&type=style&index=0&id=00dbe9b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00dbe9b0",
  null
  
)

export default component.exports